import { ActiveFiltersElement } from "@components_common/components/utils";

export default ActiveFiltersElement;
